// Shared marketplace branding — keyed by the exact backend enum strings
// (Order.marketplaceName / MarketplaceCredential.marketplaceName) so it
// composes directly with API data. Reused by later phases (Listings,
// Inventory) beyond just Orders.
export const MARKETPLACES = ['amazon', 'flipkart', 'meesho', 'myntra'];
export const MARKETPLACE_BRANDING = {
  amazon: {
    label: 'Amazon',
    activeClass: 'bg-orange-500 text-white',
    textClass: 'text-orange-600',
    dotClass: 'bg-orange-500'
  },
  flipkart: {
    label: 'Flipkart',
    activeClass: 'bg-blue-600 text-white',
    textClass: 'text-blue-600',
    dotClass: 'bg-blue-600'
  },
  meesho: {
    label: 'Meesho',
    activeClass: 'bg-pink-500 text-white',
    textClass: 'text-pink-600',
    dotClass: 'bg-pink-500'
  },
  myntra: {
    label: 'Myntra',
    activeClass: 'bg-rose-600 text-white',
    textClass: 'text-rose-600',
    dotClass: 'bg-rose-600'
  }
};

// ---------------------------------------------------------------------------
// Which marketplaces this PHASE offers a seller for LISTING.
//
// The MVP ships Meesho listing only. Amazon, Flipkart, Myntra and Shopify are
// not removed from the product — their adapters, field maps, template writers
// and imported metadata are all still here and still work, and admins go on
// importing Flipkart templates and confirming Flipkart categories so the data
// is ready for the next phase. They are simply not offered to sellers yet.
//
// Deliberately separate from MARKETPLACES above: that list is BRANDING for
// whatever data arrives (an existing Flipkart order still has to render with
// Flipkart's colours), while this one governs what a seller can newly choose.
//
// Mirrors ENABLED_MARKETPLACES in backend/src/adapters/index.js, which is the
// authority — the API refuses a marketplace outside that list regardless of
// what the UI shows. This constant exists so the UI never offers a choice the
// server will reject.
//
// Opening the next phase = add to both lists.
// ---------------------------------------------------------------------------

export const ENABLED_MARKETPLACES = ['meesho'];

export const isEnabledMarketplace = (name) =>
  ENABLED_MARKETPLACES.includes(String(name || '').toLowerCase());

/** Filters a list of marketplace keys down to what this phase offers. */
export const enabledOnly = (marketplaces = []) => marketplaces.filter(isEnabledMarketplace);

/** True while only one marketplace is live — lets a UI drop redundant tabs. */
export const SINGLE_MARKETPLACE_PHASE = ENABLED_MARKETPLACES.length === 1;

export default ENABLED_MARKETPLACES;
